<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-select v-model="queryParams.userId" filterable clearable placeholder="代理商" @change="search">
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" clearable placeholder="ICCID"></el-input>
      </el-form-item>
      <el-form-item  prop="orderNum">
        <el-input v-model="queryParams.orderNum" clearable placeholder="订单号"></el-input>
      </el-form-item>
      <el-form-item  prop="outNum" >
        <el-input v-model="queryParams.outNum" clearable placeholder="物流单号"></el-input>
      </el-form-item>
      <el-form-item  prop="phone" >
        <el-input v-model="queryParams.phone" clearable placeholder="支付手机号"></el-input>
      </el-form-item>
      <el-form-item  prop="orderStatus" >
        <el-select v-model="queryParams.orderStatus" filterable clearable placeholder="订单状态" @change="search">
          <el-option v-for="item in optOrderStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="status" >
        <el-select v-model="queryParams.status" filterable clearable placeholder="发货状态" @change="search">
          <el-option v-for="item in shipmentStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="支付开始日期"
          end-placeholder="支付结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-download" @click="handleExport" v-hasPermi="['card:change:export']"  >导出</el-button>
      </el-form-item>
    </el-form>
    
    <div class="table">
      <el-table :data="tableData" border>
        <el-table-column prop="orderNum" label="订单号" align="center" min-width="200px" fixed></el-table-column>
        <el-table-column prop="companyName" label="代理商" align="center" min-width="180px" :show-overflow-tooltip="true" fixed></el-table-column>
        <el-table-column prop="iccid" label="旧ICCID" align="center" min-width="180px">
          <template slot-scope="{row}">
            <span style="cursor: pointer;" @click="jumpButton(row.iccid)">{{row.iccid}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="changeIccid" label="新ICCID" align="center" min-width="185px">
          <template slot-scope="{row}">
            <span style="cursor: pointer;" @click="jumpButton(row.changeIccid)">{{row.changeIccid}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderMoney" label="价格" align="center"></el-table-column>
        <el-table-column prop="phone" label="收货手机号" align="center" min-width="120px"></el-table-column>
        <el-table-column prop="orderPhone" label="支付手机号" align="center" min-width="120px"></el-table-column>
        <el-table-column prop="orderStatus" label="状态" align="center" min-width="160px">
          <template slot-scope="{row}">
            <el-tag v-if="row.orderStatus == '3'">已到账</el-tag>
            <el-tag v-else-if="row.orderStatus =='1'" type="danger">未支付</el-tag>
            <el-tag v-else-if="row.orderStatus =='4'" type="warning">已退款</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="发货状态" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.status == '1'" type="warning">未发货</el-tag>
            <el-tag v-else type="success">已发货</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="outNum" label="物流单号" align="center" min-width="185px"></el-table-column>
        <el-table-column prop="updateUser" label="操作人" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="createTime" label="申请时间" align="center" min-width="185px"></el-table-column>
        <el-table-column prop="orderTime" label="支付时间" align="center" min-width="185px"></el-table-column>
        <el-table-column prop="updateTime" label="发卡时间" align="center" min-width="185px"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" min-width="185px"></el-table-column>
        <el-table-column label="操作" align="center" width="260" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary" plain
                icon="el-icon-view"
                v-hasPermi="['card:change:detail']"
                @click="infoRow(scope.row)"
              >详情</el-button>
              <el-button
                size="mini"
                type="primary" plain
                icon="el-icon-edit"
                v-hasPermi="['card:change:remark']"
                @click="remarkRow(scope.row)"
              >备注</el-button>
              <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)" v-hasPermi="['card:change:pushMessage']">
                <span class="el-dropdown-link">
                  <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="handleWechat" icon="el-icon-chat-dot-round" v-if="scope.row.focus == '1'" v-hasPermi="['card:change:pushMessage']">公众号发送</el-dropdown-item>
                  <el-dropdown-item command="handleSim" icon="el-icon-message" v-hasPermi="['card:change:pushMessage']">短信发送</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 备注的弹窗 -->
    <div>
      <el-dialog title="备注" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
        <el-form :model="beizhu" ref="beizhu">
          <el-form-item label="备注内容:" prop="remark" label-width="100px">
            <el-input v-model="beizhu.remark" autocomplete="off" style="width: 80%" placeholder="请输入备注内容"></el-input>
          </el-form-item>
          <el-form-item label="售后内容:" prop="saleRemark" label-width="100px">
            <el-input type="textarea" v-model="beizhu.saleRemark" autocomplete="off" style="width: 80%" placeholder="请输入售后内容"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" slot="footer">
          <el-button type="primary" @click="cancelDialog">取消</el-button>
          <el-button type="success" @click="saveDialog">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { agentSingleList } from "@/api/api.js"; //获取代理商下拉列表
import { changeList } from "@/api/api.js"; //补卡列表
import { exportCardChange } from "@/api/api.js"; //补卡导出
import { changePushMessage } from "@/api/api.js"; //补卡发送信息
import { changeSaveRemark } from "@/api/api.js"; //补卡备注
export default {
  name:"replacementList",
  data() {
    return{
      queryParams:{
        userId:undefined,
        iccid:undefined,
        orderNum:undefined,
        outNum:undefined,
        phone:undefined,
        orderStatus:undefined,
        status:undefined,
      },
      tableData:[],
      dateRange: [],
      page: 1,
      pageSize: 20,
      total:0,
      agentList: [],
      optOrderStatus: [
        { value: 1, label: "未支付" },
        { value: 3, label: "已到账" },
        { value: 4, label: "已退款" }
      ],
      shipmentStatus:[
         { value: 2, label: "已发货" },
         { value: 1, label: "未发货" },
      ],
      dialog:false,
      beizhu:{}
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize
      }
      changeList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    // 导出
    handleExport(){
      let params = {
        ...this.addDateRange(this.queryParams, this.dateRange),
      }
      exportCardChange(params).then(res=>{
        if (res.data.code == 200) {
          this.$notify({
            title: "提示",
            message: "已提交导出，请在任务中心查看进度",
            type: "success",
            offset:30
          });
          setTimeout(()=>{
            this.$router.push({ path: `/taskCenter/missionList`});
          },1000)
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 更多操作触发
    handleCommand(command, row) {
      switch (command) {
        case "handleWechat":
          this.sendMessage(row,1);
          break;
        case "handleSim":
          this.sendMessage(row,2);
          break;
        default:
          break;
      }
    },
    // 详情
    infoRow(row){
      this.$router.push(`/order/newCard/`+row.id);
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    //代理商下拉列表
    queryAgentList() {
      agentSingleList().then(res => {
        if (res.data.code == 200) {
          this.agentList = res.data.data;
        }
      });
    },
    // 发送信息
    sendMessage(row,val){
      let params = {
        id:row.id,
        type:val
      };
      changePushMessage(params).then(res =>{
        if(res.data.code == 200 ){
          this.$notify({
            title: '成功',
            message: '信息发送成功',
            type: 'success',
            offset:30
          });
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 备注
    remarkRow(row){
      this.beizhu = {};
      this.dialog = true;
      this.beizhu = Object.assign({}, row);
    },
    // 关闭弹窗
    dialogClose(){
      this.$refs.beizhu.clearValidate();
      this.dialog = false;
    },
    // 弹窗的取消按钮
    cancelDialog(){
      this.dialog = false;
    },
    // 弹窗的确认按钮
    saveDialog(){
      // this.dialog = false;
      let params = {
        remark:this.beizhu.remark,
        id:this.beizhu.id,
        iccid:this.beizhu.iccid,
        saleRemark:this.beizhu.saleRemark
      };
      changeSaveRemark(params).then(res =>{
        if(res.data.code == 200){
          this.$message.success("备注成功");
          this.dialog = false;
          this.beizhu = {};
          this.initData()
        }
      })
    },
    jumpButton(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
  },
  mounted() {
    this.queryAgentList();
    this.initData()
  },
  created() {

  }
};
</script>
<style scoped lang="less">

</style>


